import { parseAsStringLiteral, useQueryState } from 'nuqs';

import { countries, type Country } from './countries';

export const ADMIN_MANAGING_COUNTRY_CODES = [
  'US',
  'PR',
  'CA',
  'GB',
  'SG',
] as const;

export type AdminManagingCountryCode =
  (typeof ADMIN_MANAGING_COUNTRY_CODES)[number];

const adminManagingCountryParser = parseAsStringLiteral(
  ADMIN_MANAGING_COUNTRY_CODES,
).withDefault('US');

const getCountryByCode = (code: AdminManagingCountryCode): Country => {
  const country = countries.find(c => c.label === code);
  if (!country) {
    throw new Error(`Unknown admin managing country: ${code}`);
  }
  return country;
};

/** Managing country for Admin — URL `?country=` is the source of truth. */
export const useAdminManagingCountry = () => {
  const [countryCode, setCountryCode] = useQueryState(
    'country',
    adminManagingCountryParser,
  );

  const selectedCountry = getCountryByCode(countryCode);

  const setSelectedCountry = (country: Country) => {
    const label = country.label;
    if (!(ADMIN_MANAGING_COUNTRY_CODES as readonly string[]).includes(label)) {
      return;
    }
    void setCountryCode(label as AdminManagingCountryCode);
  };

  return {
    countryCode,
    selectedCountry,
    setCountryCode,
    setSelectedCountry,
  };
};
